import React, { useEffect, useState } from 'react';
import { auth, db } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import Topbar from './Topbar';
import './Dashboard.css';
import { syncSessionsFromFirebase } from './SyncSessions';
import { Circles } from 'react-loader-spinner';

const Dashboard = () => {
  const [user, setUser] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true); // Stato per il caricamento
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setUser(user);
        const docRef = doc(db, 'users', user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setUserInfo(docSnap.data());
          setLoading(true); // Imposta loading a true prima di sincronizzare
          await syncSessionsFromFirebase(user.uid);
          setLoading(false); // Imposta loading a false quando la sincronizzazione è terminata
        }
      } else {
        setUser(null);
        navigate('/');
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleCardClick = (toolRoute) => {
    navigate(toolRoute);
  };



  if (loading) {
    return (
      <div className="loading-overlay">
        <div className="loading-content">
          <Circles height="80" width="80" color="#ffffff" ariaLabel="loading" />
          <p>Loading... Syncing images from cloud</p>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <Topbar userInfo={userInfo} user={user} /> {/* Include Topbar */}
      <div className="dashboard-content">
        <h3>Welcome: {userInfo.firstName}! Select a tool...</h3>
        <div className="cards-container">
          {/* Card 1 */}
          <div className="card" onClick={() => handleCardClick('/tool1')}>
            <img src="tools_i3m.webp" alt="Distinguish between individuals above and below the adult age of legal
              responsibility by i3m" />
            <h4>Third Molar Maturity Index (I3M)</h4>
            <p>
              Distinguish between individuals above and below the adult age of legal
              responsibility (18 years)
            </p>
            <h5>Image source</h5>
            <p>Orthopantomography</p>
          </div>

          {/* Card 2 AI - Disponibile per tutti gli utenti */}
          <div className="card" onClick={() => handleCardClick('/tool2-ai')}>
            <div className="ai-badge">AI</div>
            <img src="tools_canini.webp" alt="Age Estimation in Adults by single-rooted teeth (AI Version)" />
            <h4>Age Estimation in Adults by single-rooted teeth (AI Version)</h4>
            <p>Pulp/tooth area ratio age estimation in adults with AI assistance</p>
            <h5>Image source</h5>
            <p>Intraoral radiographs</p>
          </div>

          {/* Additional cards... */}
          <div className="card" onClick={() => handleCardClick('/tool3')}>
            <img src="tools_carpal.webp" alt="Age estimation in children by carpal bones area" />
            <h4>Age Estimation in Children by Carpal Bones Area</h4>
            <p>Area ratio age estimation in children (carpal bones) — compatible with pediatric radiographs</p>
            <h5>Image source</h5>
            <p>Carpal X-ray (pediatric)</p>
          </div>
          {/* Additional cards... */}
          <div className="card" onClick={() => handleCardClick('/tool4')}>
            <div className="ai-badge">AI</div>
            <img src="tools_vertebra.webp" alt="Pubertal Growth Spurt Estimation by Vertebral Body Height Projections" />
            <h4>Pubertal Growth Spurt Estimation by Vertebral Body Height Projections</h4>
            <p>The Fourth Cervical Vertebra Anterior and Posterior Body Height Projections (Vba) for the Assessment of Pubertal Growth Spurt</p>
            <h5>Image source</h5>
            <p>Cervical Spine X-ray</p>
          </div>
          {/* Additional cards... */}
          <div className="card" onClick={() => handleCardClick('/tool5')}>
            <img src="tools_europeanformula.webp" alt="Age estimation in children by measurement of open apices in teeth" />
            <h4>Age estimation in children by measurement of open apices in teeth</h4>
            <p>Age estimation in children by measurement of open apices in teeth: European formula</p>
            <h5>Image source</h5>
            <p>Orthopantomography</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
